import UserCardComponent from './UserCardComponent';
export default UserCardComponent;
